export type ScopeType = "global" | "country" | "city" | "zone" | "franchise";

/**
 * The one role that bypasses every permission check. Mirrors
 * ``RBACService.SUPER_ADMIN`` on the backend, which also refuses to let this
 * role be renamed or deactivated through the Roles API -- godmode is keyed on
 * the literal name, so a rename would silently strip it here too.
 */
export const SUPER_ADMIN_ROLE = "super_admin";

/** Role names are no longer limited to a fixed set — custom roles can be created. */
export type AdminRoleName = string;

export interface Permission {
  id: number;
  codename: string;
  resource: string;
  action: string;
  description: string;
}

export interface AdminRole {
  id: number;
  name: AdminRoleName;
  display_name: string;
  description: string;
  is_active: boolean;
}

export interface UserRole {
  id: number;
  user: number;
  username: string;
  role: number;
  role_name: AdminRoleName;
  role_display_name: string;
  scope_type: ScopeType;
  scope_reference_id: number | null;
  is_active: boolean;
  assigned_by: number | null;
  assigned_by_username: string | null;
  assigned_at: string;
}

export interface RBACState {
  roles: UserRole[];
  permissions: string[];
  isLoading: boolean;
  error: string | null;
}
